export const HOST = 'https://app.yu-track.com'
export const API_HOST = 'https://app.yu-track.com/old'
